import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'TCA-TCA-angular-core',
  template: `
    <p>
      tca-angular-core works!
    </p>
  `,
  styles: []
})
export class TCAAngularCoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
